export enum EBotNames {
    TELEHEALTH_TRIAGE = "telehealthTriage"
}